var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"utxo",attrs:{"income":_vm.props.amount > 0}},[_c('p',{staticClass:"action"},[_vm._v(" "+_vm._s(_vm.$options.getActionText(_vm.props.type, _vm.props.amount, _vm.props.operationDirection))+" ")]),_c('p',{staticClass:"amount",style:({
            color: _vm.$options.getColor(_vm.props.type, _vm.props.amount),
        })},[_vm._v(" "+_vm._s(_vm.props.amount)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }